import React from 'react';
import { Link } from 'react-router-dom';
import { UserShape, TackNotificationDetailsShape, TackNotificationSelectionOptionsShape } from '../shapes';
import WordHeader from './word/header';
import Waiting from './waiting';
import TackNotificationDetails from './tack_notification_details';
import TackNotificationDetailsCheckpointDefinitions from './tack_notification_details_checkpoint_definitions';
import TackNotificationDetailsCheckpointSynonyms from './tack_notification_details_checkpoint_synonyms';
import TackNotificationArchiveDetails from './tack_notification_archive_details';
import TackNotificationArchiveCheckpointDetails from './tack_notification_archive_checkpoint_details';
import YakChat from '../containers/tack_ai_chat/yak_chat';
import PropTypes from 'prop-types';

export default class TackNotificationDetailsOrchestrator extends React.Component {
  static propTypes = {
    user: UserShape,
    tackNotificationDetails: TackNotificationDetailsShape,
    tackNotificationSelectionOptions: TackNotificationSelectionOptionsShape,
    params: PropTypes.object,
    loadComments: PropTypes.bool,
    onFetchTackNotificationDetails: PropTypes.func,
    onResetTackNofificationDetails: PropTypes.func,
    onMarkAsRead: PropTypes.func,
    onFetchSelectionOptions: PropTypes.func,
    onResetSelectionOptions: PropTypes.func
  }

  componentDidMount() {
    this.props.onResetTackNofificationDetails();
    this.props.onFetchTackNotificationDetails(this.props.params.slug);

  }

  componentDidUpdate(prevProps) {
    if (!prevProps.tackNotificationDetails.get('slug') && this.props.tackNotificationDetails.get('slug')) {
      if (!this.props.tackNotificationDetails.get('readAt') && !this.props.tackNotificationDetails.get('isCheckpoint') && !this.props.tackNotificationDetails.get('isChat')) {
        this.props.onMarkAsRead(this.props.tackNotificationDetails.get('slug'));
      }
    }
  }

  render() {
    const wordText = this.props.params.wordText || this.props.tackNotificationDetails.get('wordText');
    if (wordText){
      return (
        <div className='word'>
          <WordHeader wordText={wordText} pronunciationFile={this.props.tackNotificationDetails.get('pronunciationFile')} partOfSpeech={this.props.tackNotificationDetails.get('partOfSpeech')} mnemonicImageUrl={this.props.tackNotificationDetails.get('mnemonicImageUrl')} tackInterval={this.props.tackNotificationDetails.get('tackInterval')} />
          { this.renderBody() }
        </div>
      );
    } else {
      return null;
    }
  }

  renderBody() {
    if (this.props.tackNotificationDetails.get('loading')) {
      return this.renderRetrieving();
    } else if (this.props.tackNotificationDetails.get('error')) {
      return this.renderRetrievalError();
    } else if (this.props.tackNotificationDetails.get('isCheckpoint')) {
      if (this.props.tackNotificationDetails.get('isArchive')){
        return <TackNotificationArchiveCheckpointDetails loadComments={ this.props.loadComments } user={ this.props.user } tackNotificationDetails={ this.props.tackNotificationDetails } tackNotificationSelectionOptions={ this.props.tackNotificationSelectionOptions } onFetchSelectionOptions={ this.props.onFetchSelectionOptions } onResetSelectionOptions={ this.props.onResetSelectionOptions } />
      } else if (this.props.tackNotificationDetails.get('isReadyForSynonyms')) {
        return <TackNotificationDetailsCheckpointSynonyms loadComments={ this.props.loadComments } user={ this.props.user } tackNotificationDetails={ this.props.tackNotificationDetails } tackNotificationSelectionOptions={ this.props.tackNotificationSelectionOptions } onFetchSelectionOptions={ this.props.onFetchSelectionOptions } onResetSelectionOptions={ this.props.onResetSelectionOptions } />
      } else {
        return <TackNotificationDetailsCheckpointDefinitions loadComments={ this.props.loadComments } user={ this.props.user } tackNotificationDetails={ this.props.tackNotificationDetails } tackNotificationSelectionOptions={ this.props.tackNotificationSelectionOptions } onFetchSelectionOptions={ this.props.onFetchSelectionOptions } onResetSelectionOptions={ this.props.onResetSelectionOptions } />
      }
    } else if (this.props.tackNotificationDetails.get('isArchive')){
      return <TackNotificationArchiveDetails loadComments={ this.props.loadComments } user={ this.props.user } tackNotificationDetails={ this.props.tackNotificationDetails } />
    } else if (this.props.tackNotificationDetails.get('isChat')) {
      return (
        <YakChat
          tackSlug={this.props.tackNotificationDetails.get('slug')}
          wordText={this.props.tackNotificationDetails.get('wordText')}
          imageUrl={this.props.tackNotificationDetails.get('mnemonicImageUrl')}
          tackNotificationDetails={this.props.tackNotificationDetails}
        />
      );
    } else {
      return <TackNotificationDetails loadComments={ this.props.loadComments } user={ this.props.user } tackNotificationDetails={ this.props.tackNotificationDetails } />
    }
  }

  renderRetrievalError() {
    return(
      <div className='error'>
        Hmm, we had a problem looking up <b>{ `"${ this.props.params.slug }."` }</b> <Link to='/'>Try again?</Link>
      </div>
    )
  }

  renderRetrieving() {
    return(
      <div className='item-meta'>
        <Waiting />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/tack_notification_details_orchestrator.jsx